/**
 * 2026 Məzuniyyət Haqqı və Əməkhaqqı Hesablama Mühərriki
 * Azərbaycan Respublikasının Əmək Məcəlləsi (Maddə 114, 140, 111),
 * AR Vergi Məcəlləsi (Maddə 101, 102), "Sosial sığorta haqqında",
 * "Tibbi sığorta haqqında" və "İşsizlikdən sığorta haqqında" Qanunlara tam uyğundur.
 */

export const OFFICIAL_HOLIDAYS_2026 = [
  '2026-01-01', // Yeni il
  '2026-01-02', // Yeni il
  '2026-01-20', // Ümumxalq hüzn günü
  '2026-03-08', // Qadınlar günü
  '2026-03-20', // Novruz bayramı / Ramazan bayramı
  '2026-03-21', // Novruz bayramı / Ramazan bayramı
  '2026-03-22', // Novruz bayramı
  '2026-03-23', // Novruz bayramı
  '2026-03-24', // Novruz bayramı
  '2026-05-09', // Faşizm üzərində qələbə günü
  '2026-05-27', // Qurban bayramı
  '2026-05-28', // Müstəqillik günü / Qurban bayramı
  '2026-06-15', // Milli Qurtuluş günü
  '2026-06-26', // Silahlı Qüvvələr günü
  '2026-11-08', // Zəfər günü
  '2026-11-09', // Dövlət Bayrağı günü
  '2026-12-31', // Dünya Azərbaycanlılarının Həmrəyliyi günü
];

export const MONTH_NAMES_AZ = [
  'Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun',
  'İyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr'
];

export function isHoliday(dateObj) {
  const y = dateObj.getFullYear();
  const m = String(dateObj.getMonth() + 1).padStart(2, '0');
  const d = String(dateObj.getDate()).padStart(2, '0');
  const str = `${y}-${m}-${d}`;
  return OFFICIAL_HOLIDAYS_2026.includes(str);
}

export function calculateVacationDaysBetween(startDateStr, endDateStr) {
  if (!startDateStr || !endDateStr) return null;
  const start = new Date(startDateStr);
  const end = new Date(endDateStr);
  if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) return null;

  let totalCalendarDays = 0;
  let holidaysCount = 0;
  let holidayDates = [];

  const cur = new Date(start);
  while (cur <= end) {
    totalCalendarDays++;
    if (isHoliday(cur)) {
      holidaysCount++;
      const y = cur.getFullYear();
      const m = String(cur.getMonth() + 1).padStart(2, '0');
      const d = String(cur.getDate()).padStart(2, '0');
      holidayDates.push(`${y}-${m}-${d}`);
    }
    cur.setDate(cur.getDate() + 1);
  }

  const paidDays = totalCalendarDays - holidaysCount;
  const returnDate = new Date(end);
  returnDate.setDate(returnDate.getDate() + 1);

  return {
    totalCalendarDays,
    holidaysCount,
    paidDays,
    holidayDates,
    returnDate: returnDate.toISOString().slice(0, 10),
  };
}

export function calculateEndDateFromPaidDays(startDateStr, paidDaysNeeded) {
  if (!startDateStr || !paidDaysNeeded || paidDaysNeeded <= 0) return null;
  const start = new Date(startDateStr);
  if (isNaN(start.getTime())) return null;

  let paidDaysAccumulated = 0;
  let totalCalendarDays = 0;
  let holidaysCount = 0;
  let holidayDates = [];
  const cur = new Date(start);

  while (paidDaysAccumulated < paidDaysNeeded) {
    totalCalendarDays++;
    if (isHoliday(cur)) {
      holidaysCount++;
      const y = cur.getFullYear();
      const m = String(cur.getMonth() + 1).padStart(2, '0');
      const d = String(cur.getDate()).padStart(2, '0');
      holidayDates.push(`${y}-${m}-${d}`);
    } else {
      paidDaysAccumulated++;
    }
    if (paidDaysAccumulated < paidDaysNeeded) {
      cur.setDate(cur.getDate() + 1);
    }
  }

  const endDateStr = cur.toISOString().slice(0, 10);
  const returnDate = new Date(cur);
  returnDate.setDate(returnDate.getDate() + 1);

  return {
    endDateStr,
    totalCalendarDays,
    holidaysCount,
    paidDays: paidDaysNeeded,
    holidayDates,
    returnDate: returnDate.toISOString().slice(0, 10),
  };
}

export function getEligibleFullMonths(hireDateStr, vacationStartDateStr) {
  if (!vacationStartDateStr) return [];
  const vacStart = new Date(vacationStartDateStr);
  if (isNaN(vacStart.getTime())) return [];

  let hireDate = null;
  if (hireDateStr) {
    hireDate = new Date(hireDateStr);
    if (isNaN(hireDate.getTime())) hireDate = null;
  }

  const months = [];
  let curYear = vacStart.getFullYear();
  let curMonth = vacStart.getMonth() - 1;

  if (curMonth < 0) {
    curMonth = 11;
    curYear -= 1;
  }

  for (let i = 0; i < 12; i++) {
    const monthStart = new Date(curYear, curMonth, 1);

    if (hireDate) {
      if (monthStart < hireDate) {
        const isFirstDay = hireDate.getDate() === 1 && hireDate.getFullYear() === curYear && hireDate.getMonth() === curMonth;
        if (!isFirstDay) {
          break;
        }
      }
    }

    months.push({
      year: curYear,
      month: curMonth,
      label: `${MONTH_NAMES_AZ[curMonth]} ${curYear}`,
      key: `${curYear}-${String(curMonth + 1).padStart(2, '0')}`,
    });

    curMonth--;
    if (curMonth < 0) {
      curMonth = 11;
      curYear -= 1;
    }
  }

  return months.reverse();
}

export function calculateVacation2026({
  monthlySalaries = [],
  paidDays = 0,
  currentGrossSalary = 0,
  currentMonthWorkedPay = 0,
  sector = 'private_non_oil',
  workplaceType = 'main',
  article102Exemption = 0,
  tradeUnionRate = 0,
}) {
  const days = Math.max(0, parseInt(paidDays) || 0);
  const curGross = Math.max(0, parseFloat(currentGrossSalary) || 0);
  const workedPay = Math.max(0, parseFloat(currentMonthWorkedPay) || 0);

  const salaryList = Array.isArray(monthlySalaries)
    ? monthlySalaries
    : typeof monthlySalaries === 'object' && monthlySalaries !== null
    ? Object.values(monthlySalaries)
    : [];
  const validSalaries = salaryList.map(s => parseFloat(s) || 0);
  const totalPeriodEarning = validSalaries.reduce((sum, val) => sum + val, 0);
  const monthsCount = validSalaries.length > 0 ? validSalaries.length : 1;
  const averageMonthlyWage = totalPeriodEarning / monthsCount;

  let effectiveMonthlyBase = averageMonthlyWage;
  let isProtectedByCurrentSalary = false;

  if (curGross > 0 && curGross > averageMonthlyWage) {
    effectiveMonthlyBase = curGross;
    isProtectedByCurrentSalary = true;
  }

  const dailyWage = effectiveMonthlyBase / 30.4;
  const grossVacationPay = dailyWage * days;
  const totalGrossIncome = grossVacationPay + workedPay;

  const isPrivate = sector === 'private_non_oil';
  const isMainWorkplace = workplaceType === 'main';

  let standardExemption = 0;
  if (isMainWorkplace) {
    if (totalGrossIncome <= 2500) {
      standardExemption = 200;
    }
  }

  const totalExemption = standardExemption + (parseFloat(article102Exemption) || 0);
  const taxableIncome = Math.max(0, totalGrossIncome - totalExemption);

  let incomeTax = 0;
  if (isPrivate) {
    if (taxableIncome <= 8000) {
      incomeTax = 0;
    } else {
      incomeTax = (taxableIncome - 8000) * 0.14;
    }
  } else {
    if (taxableIncome <= 2500) {
      incomeTax = taxableIncome * 0.14;
    } else {
      incomeTax = 350 + (taxableIncome - 2500) * 0.25;
    }
  }

  let dsmfEmployee = 0;
  let dsmfEmployer = 0;
  if (isPrivate) {
    if (totalGrossIncome <= 200) {
      dsmfEmployee = totalGrossIncome * 0.03;
      dsmfEmployer = totalGrossIncome * 0.22;
    } else {
      dsmfEmployee = 6 + (totalGrossIncome - 200) * 0.10;
      dsmfEmployer = 44 + (totalGrossIncome - 200) * 0.15;
    }
  } else {
    dsmfEmployee = totalGrossIncome * 0.03;
    dsmfEmployer = totalGrossIncome * 0.22;
  }

  const unemploymentEmployee = totalGrossIncome * 0.005;
  const unemploymentEmployer = totalGrossIncome * 0.005;

  let itsEmployee = 0;
  let itsEmployer = 0;
  if (totalGrossIncome <= 8000) {
    itsEmployee = totalGrossIncome * 0.02;
    itsEmployer = totalGrossIncome * 0.02;
  } else {
    itsEmployee = 160 + (totalGrossIncome - 8000) * 0.005;
    itsEmployer = 160 + (totalGrossIncome - 8000) * 0.005;
  }

  const tradeUnionFee = totalGrossIncome * ((parseFloat(tradeUnionRate) || 0) / 100);
  const totalDeductions = incomeTax + dsmfEmployee + unemploymentEmployee + itsEmployee + tradeUnionFee;
  const netIncome = Math.max(0, totalGrossIncome - totalDeductions);

  const vacationRatio = totalGrossIncome > 0 ? (grossVacationPay / totalGrossIncome) : 1;
  const netVacationPay = netIncome * vacationRatio;
  const netWorkedPay = netIncome * (1 - vacationRatio);

  const totalEmployerCosts = dsmfEmployer + unemploymentEmployer + itsEmployer;
  const superGross = totalGrossIncome + totalEmployerCosts;

  return {
    totalPeriodEarning: round2(totalPeriodEarning),
    monthsCount,
    averageMonthlyWage: round2(averageMonthlyWage),
    currentGrossSalary: round2(curGross),
    effectiveMonthlyBase: round2(effectiveMonthlyBase),
    isProtectedByCurrentSalary,
    dailyWage: round2(dailyWage),
    paidDays: days,
    grossVacationPay: round2(grossVacationPay),
    currentMonthWorkedPay: round2(workedPay),
    totalGrossIncome: round2(totalGrossIncome),
    standardExemption: round2(standardExemption),
    totalExemption: round2(totalExemption),
    taxableIncome: round2(taxableIncome),
    incomeTax: round2(incomeTax),
    dsmfEmployee: round2(dsmfEmployee),
    dsmfEmployer: round2(dsmfEmployer),
    unemploymentEmployee: round2(unemploymentEmployee),
    unemploymentEmployer: round2(unemploymentEmployer),
    itsEmployee: round2(itsEmployee),
    itsEmployer: round2(itsEmployer),
    tradeUnionFee: round2(tradeUnionFee),
    totalDeductions: round2(totalDeductions),
    netIncome: round2(netIncome),
    netVacationPay: round2(netVacationPay),
    netWorkedPay: round2(netWorkedPay),
    totalEmployerCosts: round2(totalEmployerCosts),
    superGross: round2(superGross),
    sector,
    workplaceType,
    article102Exemption,
    tradeUnionRate,
  };
}

function round2(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}
